var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIonic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_305_758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0002 10.8818C17.5827 10.8836 15.2647 11.8446 13.5551 13.5539C11.8455 15.2632 10.884 17.581 10.8818 19.9985C10.884 22.4157 11.8453 24.7333 13.5545 26.4425C15.2637 28.1518 17.5813 29.113 19.9985 29.1152C22.4157 29.113 24.7333 28.1518 26.4425 26.4425C28.1518 24.7333 29.113 22.4157 29.1152 19.9985C29.1112 17.5821 28.1497 15.2658 26.4412 13.557C24.7327 11.8482 22.4166 10.8862 20.0002 10.8818Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0834 11.6932C35.3791 11.6932 37.2401 9.83221 37.2401 7.53655C37.2401 5.24089 35.3791 3.37988 33.0834 3.37988C30.7878 3.37988 28.9268 5.24089 28.9268 7.53655C28.9268 9.83221 30.7878 11.6932 33.0834 11.6932Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 40.0001C31.0317 40.0001 40 31.0318 40 20.0001C40 17.1168 39.3983 14.3284 38.2033 11.7118L38.2017 11.7101L38.03 11.3268L37.7483 11.6401C37.0683 12.4134 36.2017 13.0068 35.24 13.3668L34.975 13.4684L35.085 13.7268C35.917 15.7045 36.3421 17.8295 36.335 19.9751V19.9918C36.335 29.0001 29.0067 36.3351 19.9917 36.3351C10.9767 36.3351 3.655 29.0068 3.655 19.9984C3.655 10.9901 10.9917 3.65511 19.9983 3.65511C22.4433 3.65511 24.8033 4.18678 26.9983 5.23344L27.2567 5.35844L27.3667 5.10011C27.79 4.13011 28.4167 3.31677 29.1983 2.68844L29.21 2.67844L29.5383 2.41344L29.1633 2.21844C26.3492 0.750863 23.2205 -0.0104498 20.0467 0.000108338H20C8.96833 0.000108338 0 8.96844 0 20.0001C0 31.0318 8.96833 40.0001 20 40.0001Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_305_758"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIonic);
export default __webpack_public_path__ + "static/media/ionic.f62775f25086997b33b1e368a7616269.svg";
export { ForwardRef as ReactComponent };